<div class="text-left border-right pr-2">
    Token Refresh: {{ remainingTime }}
</div>



// WEBPACK FOOTER //
// ./src/app/core/components/session-timer/session-timer.component.html